import { render, staticRenderFns } from "./RewardsCarousel.vue?vue&type=template&id=18b99992&scoped=true&"
import script from "./RewardsCarousel.vue?vue&type=script&lang=js&"
export * from "./RewardsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./RewardsCarousel.vue?vue&type=style&index=0&id=18b99992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b99992",
  null
  
)

export default component.exports